import {Injectable} from "@angular/core";

@Injectable()
export class NonprofitNamesCacheService {

  contextApi = '/api';
  constructor() {}

  private cache: string[] = [];

  public geCache(): string[] {
    return this.cache;
  }
}
